import { isSahDeliveryStatus, sahDeliveryStatusLabel } from '@statura/utils/sah-delivery-ladder';

/**
 * A readiness item belongs to the head provider only for the exact associated
 * brokerage relationship. Keeping this predicate shared prevents a registered
 * provider, or a non-brokered client, from having genuine local gaps hidden.
 */
export function isSahReadinessHeldByHeadProvider(input: {
  operatingModel: string | null | undefined;
  operatesUnderRegisteredProviderId: string | null | undefined;
  settlementModel: string | null | undefined;
  headRegisteredProviderId: string | null | undefined;
}): boolean {
  return (
    input.operatingModel === 'associated' &&
    typeof input.operatesUnderRegisteredProviderId === 'string' &&
    input.operatesUnderRegisteredProviderId.length > 0 &&
    input.settlementModel === 'brokered_out' &&
    input.headRegisteredProviderId === input.operatesUnderRegisteredProviderId
  );
}

/** Shown where an associated provider has no local funding status to report. */
export const SAH_HELD_BY_HEAD_PROVIDER_LABEL = 'Held by head provider';

/**
 * Delivery-status wording for a client record. A brokered client of an
 * associated provider has no local support plan, so the projection returns no
 * status: that record is the head provider's, not an unknown one. Recognised
 * statuses, and every client not held by a head provider, keep the shared
 * ladder label.
 */
export function sahRecordDeliveryStatusLabel(input: {
  deliveryStatus: string | null | undefined;
  heldByHeadProvider?: boolean | null;
}): string {
  if (input.heldByHeadProvider === true && !isSahDeliveryStatus(input.deliveryStatus)) {
    return SAH_HELD_BY_HEAD_PROVIDER_LABEL;
  }
  return sahDeliveryStatusLabel(input.deliveryStatus);
}
